export default {"src":"/_next/static/media/logo-apple-podcast.bb780192.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};